// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audience-breakdown{font-family:'Fira Code';font-size:1rem;overflow:auto}.audience-breakdown table{border-spacing:10px;border-collapse:separate}.audience-breakdown *{color:#1E2B4E;font-weight:600}.audience-breakdown .table-header{text-align:right}.audience-breakdown .col-header{color:#7E8FB1}.audience-breakdown .row-header{color:#1E2B4E;text-align:right}.audience-breakdown__value{background:#8cf3b4;font-family:'Poppins';text-align:center;font-size:1rem;font-weight:600}\n", ""]);
// Exports
module.exports = exports;
